import React, {Component} from 'react'

function Paragraph(props) {
    return props.text.split('\n').map((p, i) => <p style={{margin:props.noGap?0:i==0?0:null}} key={'p ' + i}>{p}</p>)
}

export default Paragraph;